<vdr-card title="Shipping SMS (배송 SMS)" style="margin-top: 1rem">
  <div class="form-grid">
    <vdr-form-field label="Send shipping SMS to B2B (corporate)">
      <clr-toggle-wrapper>
        <input type="checkbox" clrToggle [(ngModel)]="b2b" />
      </clr-toggle-wrapper>
    </vdr-form-field>

    <vdr-form-field label="Send shipping SMS to B2C (general)">
      <clr-toggle-wrapper>
        <input type="checkbox" clrToggle [(ngModel)]="b2c" />
      </clr-toggle-wrapper>
    </vdr-form-field>
  </div>

  <button
    class="btn btn-primary"
    style="margin-top: 0.5rem"
    (click)="save()"
    [disabled]="saving"
  >
    {{ "common.update" | translate }}
  </button>
</vdr-card>
